import { createContext, useContext } from "react";

interface TourMobileContextValue {
  openSidebar: () => void;
}

export const TourMobileContext = createContext<TourMobileContextValue>({
  openSidebar: () => {},
});

export const useTourMobile = () => useContext(TourMobileContext);
